module.exports = __webpack_public_path__ + "media/audio39.6f31e4b5.mp3";